/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Model_Usage_BreakdownInputs */



/**
* | output |
* | --- |
* | "Usage Breakdown" |
*
* @param {Dashboard_Model_Usage_BreakdownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_model_usage_breakdown = /** @type {((inputs?: Dashboard_Model_Usage_BreakdownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Model_Usage_BreakdownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzungsaufteilung")
	return /** @type {LocalizedString} */ ("Usage Breakdown")
});